import { defineStore } from 'pinia';
import { api } from '@/utils/api';

export const usePaymentStore = defineStore('payment', {
    state: () => ({
        payments: [],
        paymentsHistory: [],
        loading: false,
        error: null,
        paymentMethods: [],
        lastPaymentMethod: null
    }),
    actions: {
        async subscribe(tariffId) {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.post('/payments/subscribe', null, { params: { tariffId } });
                console.log(response.data);
                if (response.data) {
                    window.location.href = response.data;
                }
            } catch (error) {
                this.error = error.response?.data?.message || 'Ошибка подписки';
                throw error;
            } finally {
                this.loading = false;
            }
        },

        async unsubscribe() {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.post('/payments/unsubscribe');
                console.log(response.data);
            } catch (error) {
                this.error = error.response?.data?.message || 'Ошибка подписки';
                throw error;
            } finally {
                this.loading = false;
            }
        },

        async unbindCard(methodId) {
            this.loading = true;
            this.error = null;
            try {
                console.log(methodId);
                const response = await api.delete(`/payment_methods/${methodId}`);
                console.log(response.data);
                // this.paymentMethods = [];
            } catch (error) {
                this.error = error.response?.data?.message || 'Ошибка подписки';
                throw error;
            } finally {
                this.loading = false;
            }
        },

        async addPaymentMethod() {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.post('/payment_methods');
                console.log(response.data);
                if (response.data) {
                    window.location.href = response.data;
                }
            } catch (error) {
                this.error = error.response?.data?.message || 'Ошибка подписки';
                throw error;
            } finally {
                this.loading = false;
            }
        },

        async newPayment() {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.post('/payments/new');
                console.log(response.data);
                if (response.data) {
                    window.location.href = response.data;
                }
            } catch (error) {
                this.error = error.response?.data?.message || 'Ошибка подписки';
                throw error;
            } finally {
                this.loading = false;
            }
        },

        async fetchPaymentsHistory(page = 0, size = 10) {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.get('/payments/my', {
                    params: {
                        page,
                        size
                    }
                });
                console.log(response.data);
                this.paymentsHistory = response.data;
            } catch (error) {
                this.error = error.response?.data?.message || 'Ошибка подписки';
                throw error;
            } finally {
                this.loading = false;
            }
        },

        async fetchMyPaymentMethods() {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.get('/payment_methods');
                console.log(response.data);
                this.paymentMethods = response.data;
            } catch (error) {
                this.error = error.response?.data?.message || 'Ошибка подписки';
                throw error;
            } finally {
                this.loading = false;
            }
        },

        async subscribeCustom({ maxCompanies, storageLimitBytes, dailyTokenLimit }) {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.post('/payments/subscribe/custom', {
                    maxCompanies,
                    storageLimitBytes,
                    dailyTokenLimit,
                });
                if (response.data) {
                    window.location.href = response.data;
                }
            } catch (error) {
                this.error = error.response?.data?.message || 'Ошибка оформления кастомного тарифа';
                throw error;
            } finally {
                this.loading = false;
            }
        },

        async fetchLastPaymentMethod() {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.get('/payment_methods/last');
                console.log(response.data);
                this.lastPaymentMethod = response.data;
            } catch (error) {
                this.error = error.response?.data?.message || 'Ошибка подписки';
                throw error;
            } finally {
                this.loading = false;
            }
        }
    }
});
